// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1bJOR","actions":"GroupTable_actions__3jZ-G","deleteModalFooter":"GroupTable_deleteModalFooter__3sZOn"};